import React from 'react';
import PropTypes from 'prop-types';
import CodeMirror from 'codemirror';
import 'codemirror/addon/runmode/runmode';
import 'codemirror/mode/jsx/jsx';
import 'codemirror/mode/shell/shell';
import '../styles/codemirror.scss';
import '../styles/codemirror-solarized.scss';

import marked from 'marked';
const renderer = new marked.Renderer();

renderer.heading = (text, level) => {
	const escapedText = text.toLowerCase().replace(/[^\w]+/g, '-');

	let sldsClass;
	if (level === 1) {
		return `<header class="site-masthead slds-grid slds-wrap bb-gray slds-m-bottom--medium">
				<div class="site-masthead-title slds-col slds-has-flexi-truncate slds-align-middle">
					<div class="slds-media slds-media--center slds-media--responsive">
						<span class="slds-media__figure">
							<img src="/slds-site-assets/images/header-components.svg" alt />
						</span>
						<div class="slds-media__body">
							<div class="slds-grid">
								<h1 id="${escapedText}">${text}</h1>
							</div>
						</div>
					</div>
				</div>
			</header>`;
	} else if (level === 2) {
		sldsClass = 'slds-m-top--large slds-text-heading--medium';
	} else if (level === 3) {
		sldsClass = 'slds-m-top--large slds-text-heading--small';
	} else {
		sldsClass = 'slds-m-top--large slds-text-heading--label';
	}

	return `<h${level} id="${escapedText}" class="${sldsClass}">${text}</h${level}>`;
};

marked.setOptions({
	highlight (code, lang) {
		const el = document.createElement('div');
		el.className = 'CodeMirror cm-s-default site-code--content';
		CodeMirror.runMode(code, lang || 'jsx', el);
		return el.outerHTML;
	},
	renderer
});

function renderContents (markdown = '', replacements = { }) {
	const replacedText = markdown.replace(/\${(.+?)}/g, (match, p1) => replacements[p1]);
	return { __html: marked(replacedText) };
}

const MarkdownRenderer = (props) => (
	<div
		className={`slds-text-longform ${props.className}`}
		dangerouslySetInnerHTML={renderContents(props.markdown, props.replacements)}
	>
	</div>
);

MarkdownRenderer.displayName = 'MarkdownRenderer';

MarkdownRenderer.propTypes = {
	className: PropTypes.string,
	markdown: PropTypes.string,
	replacements: PropTypes.object
};

export default MarkdownRenderer;



// WEBPACK FOOTER //
// ./public/src/components/markdown-renderer.jsx